import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=5cf2e24e&"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js&"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports